import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const getLogs = async (type, firstCursor, lastCursor, prev) => {
    const urlParams = Utils.getUrlParams({ prev, firstCursor, lastCursor });

    const log = await RequestManager.get({
        url: "/log/v1/" + type + urlParams
    });
    return log.data;
};

const Log = {
    getLogs

};

export default Log;